import { render, staticRenderFns } from "./moreadd.vue?vue&type=template&id=78bf6ff2&"
import script from "./moreadd.vue?vue&type=script&lang=js&"
export * from "./moreadd.vue?vue&type=script&lang=js&"
import style0 from "./moreadd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports